const POSTCODE_REGEX = /^[\d]{4}$/;

export function isValidPostcode(val: string) {
    return val.length === 0 || Boolean(val.match(POSTCODE_REGEX));
}
